// @flow

import React from 'react';
import { withErrorEmptyComponent } from '../emptyComponent';
import { Submit } from './fields';
import fieldMapping from './fields/mapping';
import type { ACFFormData } from './types';
import Formidable from './formidable';

type ACFProps = {|
  onSuccess?: Function,
  form_data: ACFFormData,
|};

const ACFFormidable = ({
  onSuccess,
  form_data: {
    form_key,
    fields,
    options: {
      submit_value,
      success_msg,
    },
  },
}: ACFProps) => {
  const initialValues = fields.reduce((acc, field) => {
    if (!field.default_value) {
      return acc;
    }

    return {
      ...acc,
      [field.field_key]: field.default_value,
    };
  }, {});

  return (
    <Formidable
      form={form_key}
      initialValues={initialValues}
      successMsg={success_msg}
      fields={fields}
      onSuccess={onSuccess}
    >
      {fields.map(({ type, ...fieldProps }) => {
        const EmptyComponent = withErrorEmptyComponent(`Couldn't map field ${type} to a known
          field in FormidableACF`);
        const Component = fieldMapping[type] || EmptyComponent;
        return <Component form={form_key} key={fieldProps.field_key} {...fieldProps} />;
      })}
      <Submit form={form_key} buttonText={submit_value} />
    </Formidable>
  );
};

ACFFormidable.defaultProps = {
  onSuccess: () => {},
};

export default ACFFormidable;
